import { withInstall } from '@tw-element/utils'
import CheckTag from './src/check-tag.vue'

export const TwCheckTag = withInstall(CheckTag)
export default TwCheckTag

export * from './src/check-tag'
